import { useEffect, useState } from 'react'
import { getTaskByID } from '../../api/tasks'
import { TaskProps } from '../../interfaces/tasks_types'
import { useParams } from 'react-router-dom'
import { TaskForm } from './Form/TaskForm'
import { useAuth } from '../../App'
import { getProject } from '../../api/projects'
import { Roles } from '@/interfaces/employee_type'

/**
 *  ### Route for ('/tasks/create_task')
 * 
 */
export function CreateTask() {
  return (
    <TaskForm method="POST"/>
  )
}

/**
 *  ### Route for ('/tasks/update_task/:id')
 * 
 * 
 */
export function EditTask() {
  const { id } = useParams<string>()
  const [task_data, setTaskData] = useState<TaskProps>()
  
  useEffect(() => {
    if (!id) return
    const fetchData = async () => {
      try {
        const task = await getTaskByID(id)

        if (!task) {
          throw new Error("Error fetching task data")
        }

        setTaskData({...task, task_id: id})
      }

      catch (error) {
        console.error(error)
      }
    }

    fetchData()


  }, [id])
  return (
    <>
      {task_data && <TaskForm method="PUT" task_data={task_data}/>}
    </>
  )
}

/**
 *  ### Route for ('/tasks/create_task_from_project')
 * 
 *  This is a seperate route for creating a task from a project card
 * 
 * I might want to just use the TaskForm component for this...
 */
export function CreateTaskFromProject(){
  const { id } = useParams<string>()
  const { user } = useAuth()

  const [task_data, setTaskData] = useState<TaskProps>()

  useEffect(() => {
    if (!id) return

    const fetchData = async () => {
      try {
        const project = await getProject(id)

        if (!project) {
          throw new Error("Error fetching task data")
        }

        // I need it in this format because the TaskForm find the project in this format...
        // Yet another hacky solution...

        setTaskData({
          task_id: "",
          project: project.data.project_name,
          project_id: project.data.project_id ?? "",
          project_name: project.data.project_name ?? "",
          title: "",
          description: "",
          assigned_by: "",
          assigned_by_obj: {
            name: user?.name ?? "",
            email: user?.email ?? "",
            role: user?.role as Roles,
            username: user?.username ?? "",
            password: user?.password ?? "",
          },
          assigned_to: "",
          due_date: new Date().toLocaleDateString('en-CA'),
          status: "Active",
          category: "Other",
          completion_percentage: 0
        })
      }
      catch (error) {
        console.error(error)
      }
    }

    fetchData()
  }, [id, user])

  return (
    <>
      {task_data && <TaskForm method="POST" task_data={task_data}/>}
    </>
  )
}
